// extracted by mini-css-extract-plugin
export var dropdownButton = "_3l-0";
export var fullWidthDropdownButton = "_3l-1";
export var icon = "_3l-3";
export var iconPlaceholder = "_3l-2";
export var menuItemRow = "_3l-5";
export var shortcutContainer = "_3l-4";